import { createApi } from "@reduxjs/toolkit/query/react";

import { viteEnv } from "utils/vite-env.util";

import { commsBaseQueryWithJWTReauthFn } from "./utils/auth.utils";

export const SUNO_COMMS_API_TAGS = [
  "CallLogs",
  "CallLocations",
  "CallLocationSettings",
  "CallUser",
  "CallUserSettings",
  "CallCustomers",
  "CallMetrics",
  "LeadUsers",
  "LeadContacts",
  "LeadContactsCount",
  "LeadMessages",
  "LeadEmailMessages",
  "LeadMessagesCount",
  "LeadEmails",
  "LeadInbox",
  "ContactConversations",
  "CommsAuth",
  "LeadPatients",
  "LeadsSettings",
  "ServiceInterests",
  "Tags",
  "TagRules",
  "AssignedTags",
  "Campaigns",
  "Campaign",
  "CampaignVersions",
  "CampaignTriggerRules",
  "CampaignParticipants",
  "CampaignParticipant",
  "CampaignMetrics",
  "CampaignEvents",
  "NotificationSettings",
  "NotificationSettingRules"
];

export const sunoCommsApi = createApi({
  reducerPath: "comms-api",
  baseQuery: commsBaseQueryWithJWTReauthFn(viteEnv.VITE_SUNO_COMMS_API),
  tagTypes: SUNO_COMMS_API_TAGS,
  endpoints: () => ({})
});
